import type { ExportJob } from '../api/contracts'

/** What one email carries, at most (the server's `SEND_MAX_BYTES`). */
export const SEND_MAX_BYTES = 20 * 1024 * 1024

/** "12 KB", "4.2 MB", as the email itself says it. */
export function fileSizeWords(size: number): string {
  if (size < 1024 * 1024) return `${Math.max(1, Math.round(size / 1024))} KB`
  return `${(size / (1024 * 1024)).toFixed(1)} MB`
}

/** The subject to start with: the file's name, or the first and how many more. */
export function defaultSubject(exports: Pick<ExportJob, 'file_name'>[]): string {
  const name = (file: string) => file.replace(/\.[^.]+$/, '')
  if (exports.length === 1) return name(exports[0].file_name)
  return `${name(exports[0].file_name)} and ${exports.length - 1} more`
}
